import React, { useEffect, useState } from 'react'
import { FormattedMessage } from 'react-intl'

import FromToIcon from 'assets/icons/from-left-to-right-icon'
import capitalize from 'utils/capitalize'
import { renderRoleIconName, renderStatusIcon } from '../userTable'
import Select from 'components/Select'
import roles, {
  INDIVIDUAL_ROLE,
  INDIVIDUAL_ROLE_ID,
  NCG_ROLE,
  NCG_ROLE_ID,
  RFP_ROLE_ID,
  SECRETARIAT_ROLE_ID,
  BIRDLIFE_SECRETARIAT_ROLE_ID
} from 'constants/roles'
import { PENDING_USER_STATUS_ID, ACTIVE_USER_STATUS_ID } from 'constants/userStatuses'
import Button from 'components/Button'
import { requestApproveRole, requestDeclineRole, requestSecretariatChangeRole } from 'api/user'

import {
  TableUSerModalActiveFooter,
  TableUserModalContainer,
  TableUserModalData,
  TableUserModalDataDivider,
  TableUserModalDataIcon,
  TableUserModalDataItem,
  TableUserModalDataItemCategory,
  TableUserModalDataItemStatus,
  TableUserModalDataItemText,
  TableUserModalFooter,
  TableUserModalFooterButtonWrapper,
  TableUserModalFooterDeclineApproveWrapper,
  TableUserModalSelectWrapper,
  TableUserModalUserTypeChangeWrapper
} from './style'

const roleMapping = {
  Individual: 'Individual',
  'National Coordination Group': 'NCG',
  'Regional Focal Point': 'RFP'
}

const availableRoles = roles
  .filter((role) => {
    return role.value !== SECRETARIAT_ROLE_ID && role.value !== BIRDLIFE_SECRETARIAT_ROLE_ID
  })
  .map((role) => {
    return {
      label: roleMapping[role.label],
      value: role.value
    }
  })

const firstNameLastNameChar = 0

const TableUserModal = ({ user, toggleModal, getUsers }) => {
  const requestedRole = roles.find((role) => {
    return role.value === user.RequestedRoleId
  })
  const [isAbleToChangeRole, setIsAbleToChangeRole] = useState(false)
  const [userRole, setUserRole] = useState(
    user.Role.id === INDIVIDUAL_ROLE_ID
      ? { label: 'Individual', value: INDIVIDUAL_ROLE_ID }
      : user.Role.id === NCG_ROLE_ID
        ? { label: 'NCG', value: NCG_ROLE_ID }
        : { label: 'RFP', value: RFP_ROLE_ID }
  )

  useEffect(() => {
    if (user.Role.id === userRole.value) {
      setIsAbleToChangeRole(false)
    } else {
      setIsAbleToChangeRole(true)
    }
  }, [userRole])

  console.log(user)

  function handleChangeRole(e) {
    setUserRole(e)
  }

  function closeModal() {
    toggleModal(false)
  }

  function changeRole() {
    closeModal()
    requestSecretariatChangeRole({
      userId: user.id,
      newRoleId: userRole.value
    }).then((data) => {
      console.log(data)
      getUsers()
    })
  }

  function approveChangeRole() {
    closeModal()
    requestApproveRole(user.id).then((data) => {
      console.log(data)
      getUsers()
    })
  }

  function declineChangeRole() {
    closeModal()
    requestDeclineRole(user.id).then((data) => {
      console.log(data)
      getUsers()
    })
  }

  return (
    <TableUserModalContainer data-testid='test-user-modal-container'>
      <TableUserModalDataIcon>
        {capitalize(user.firstName.charAt(firstNameLastNameChar))}
        {capitalize(user.lastName.charAt(firstNameLastNameChar))}
      </TableUserModalDataIcon>
      <TableUserModalData>
        <TableUserModalDataItem data-test="user-modal-item">
          <TableUserModalDataItemCategory data-test="user-modal-label">
            <FormattedMessage id="categoryName" />
          </TableUserModalDataItemCategory>
          <TableUserModalDataItemText data-test="user-modal-name">
            {capitalize(user.firstName)} {capitalize(user.lastName)}
          </TableUserModalDataItemText>
        </TableUserModalDataItem>
        <TableUserModalDataDivider />
        <TableUserModalDataItem data-test="user-modal-item">
          <TableUserModalDataItemCategory data-test="user-modal-label">
            <FormattedMessage id="organization" />
          </TableUserModalDataItemCategory>
          <TableUserModalDataItemText data-test="user-modal-organization">{user.organization ? user.organization : 'none'}</TableUserModalDataItemText>
        </TableUserModalDataItem>
        <TableUserModalDataDivider />
        <TableUserModalDataItem data-test='user-modal-item'>
          <TableUserModalDataItemCategory data-test="user-modal-label">
            <FormattedMessage id="country" />
          </TableUserModalDataItemCategory>
          <TableUserModalDataItemText data-test="user-modal-country">{capitalize(user.Country.name)}</TableUserModalDataItemText>
        </TableUserModalDataItem>
        <TableUserModalDataDivider />
        <TableUserModalDataItem data-test='user-modal-item'>
          <TableUserModalDataItemCategory data-test="user-modal-label">
            <FormattedMessage id="email" />
          </TableUserModalDataItemCategory>
          <TableUserModalDataItemText data-test="user-modal-email">{user.email}</TableUserModalDataItemText>
        </TableUserModalDataItem>
        <TableUserModalDataDivider />
        <TableUserModalDataItem data-test='user-modal-item'>
          <TableUserModalDataItemCategory data-test="user-modal-label">
            <FormattedMessage id="userType" />
          </TableUserModalDataItemCategory>
          {user.UserStatus.id === ACTIVE_USER_STATUS_ID && (
            <TableUserModalSelectWrapper>
              <Select
                options={availableRoles}
                height="40px"
                field="status"
                marginTop="0px"
                placeholder="User type"
                value={userRole}
                onChange={handleChangeRole}
              />
            </TableUserModalSelectWrapper>
          )}
          {user.UserStatus.id === PENDING_USER_STATUS_ID && (
            <TableUserModalUserTypeChangeWrapper data-test='user-modal-role-change'>
              {renderRoleIconName(user.Role.name)}
              <FromToIcon />
              {renderRoleIconName(requestedRole.value === INDIVIDUAL_ROLE_ID ? INDIVIDUAL_ROLE : NCG_ROLE)}
            </TableUserModalUserTypeChangeWrapper>
          )}
        </TableUserModalDataItem>
        <TableUserModalDataDivider />
        <TableUserModalDataItem data-test='user-modal-item'>
          <TableUserModalDataItemCategory data-test="user-modal-label">
            <FormattedMessage id="status" />
          </TableUserModalDataItemCategory>
          <TableUserModalDataItemStatus data-test="user-modal-status">
            <TableUserModalDataItemText>{capitalize(user.UserStatus.name)}</TableUserModalDataItemText>
            {renderStatusIcon(user.UserStatus.name)}
          </TableUserModalDataItemStatus>
        </TableUserModalDataItem>
      </TableUserModalData>
      {user.UserStatus.id === PENDING_USER_STATUS_ID && (
        <TableUserModalFooter>
          <TableUserModalFooterButtonWrapper onClick={closeModal}>
            <Button dataTest='cancel' type="secondary">Cancel</Button>
          </TableUserModalFooterButtonWrapper>
          <TableUserModalFooterDeclineApproveWrapper>
            <TableUserModalFooterButtonWrapper onClick={declineChangeRole}>
              <Button dataTest='decline' type="destructive">Decline</Button>
            </TableUserModalFooterButtonWrapper>
            <TableUserModalFooterButtonWrapper marginLeft={true} onClick={approveChangeRole}>
              <Button dataTest='submit' type='primary'>Approve request</Button>
            </TableUserModalFooterButtonWrapper>
          </TableUserModalFooterDeclineApproveWrapper>
        </TableUserModalFooter>
      )}
      {user.UserStatus.id === ACTIVE_USER_STATUS_ID && (
        <TableUSerModalActiveFooter>
          <TableUserModalFooterButtonWrapper onClick={closeModal}>
            <Button dataTest='cancel' type="secondary">Cancel</Button>
          </TableUserModalFooterButtonWrapper>
          <TableUserModalFooterButtonWrapper marginLeft={true} onClick={changeRole}>
            <Button dataTest='submit' type={isAbleToChangeRole? 'primary' : 'disabledPrimary'} isDisabled={!isAbleToChangeRole}>Save changes</Button>
          </TableUserModalFooterButtonWrapper>
        </TableUSerModalActiveFooter>
      )}
    </TableUserModalContainer>
  )
}

export default TableUserModal
